<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size * 11 / 6"
    viewBox="0 0 6 11"
  >
    <g>
      <path
        :fill="color"
        d="M5.723 5.311L1.465 1.04a.616.616 0 0 0-.86 0 .616.616 0 0 0 0 .86L4.44 5.734.604 9.57a.616.616 0 0 0 0 .86.616.616 0 0 0 .86 0l4.26-4.258a.616.616 0 0 0 0-.86z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#71767D',
    },
    size: {
      type: Number,
      default: 6,
    },
  },
};
</script>
